import styled from '@emotion/styled';

import MuiSwitch from '../../../MuiFields/Switch';

import useTableStore from '../../../../store/table';

// useContext hook to access the table store
import { useTableId } from '../../../../contexts/TableId'; 

const SwitchContainer = styled.div`
  margin-bottom: 1.4rem;
  border: 1px solid ${props => props.theme.colors.border};
  background-color: white;
  padding: 1.5rem;
  border-radius: 3px;
`;

const SwitchComponent = ({ field, subfield = "$gt", val, label }) => {
  const tableId = useTableId(); // Get the table ID from context

  const resetFilters = useTableStore(state => state.resetTableFilters);
  const handleFilter = useTableStore(state => state.handleTableFilter);
  let fieldValue = useTableStore(state => state.tableFilters[tableId]?.[field]) || {};

  let fieldChecked = fieldValue && (fieldValue[subfield] || fieldValue[subfield] === 0) ? true : false;

  const toggleSwitch = (e) => {
    let checked = e.target.checked;
    if (checked) {
      handleFilter({target: {value: val}}, tableId, field, subfield, "number");
    } else {
      resetFilters(tableId, field, subfield, false);
    }
  };

  console.log(fieldChecked, "dkfjdlfjlk")

  return (
    <SwitchContainer>
      <MuiSwitch label={label} onChange={toggleSwitch} checked={fieldChecked} size="small" />
    </SwitchContainer>
  );
};

export default SwitchComponent;